<template>
    <div class="relative">
<!--        <div class="vx-navbar-wrapper nav-menu-wrapper">-->
            <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColor">

                <ul class="menu-items flex w-full items-center">
                    <li
                        class="menu-item"
                        v-for="(item, index) in menuItemsUpdated"
                        :key="index">

                        <!--                        <template v-if="item.header">-->
                        <!--                            <h-nav-menu-header :header="item" class="menu-header relative"/>-->
                        <!--                        </template>-->


                        <!-- If it's link -->
                        <div v-if="!item.submenu && checkWorkSpaceNavItem(item)" class="menu-link">
                            <h-nav-menu-item
                                v-if="!item.submenu && checkWorkSpaceNavItem(item)"
                                class="relative py-4 cursor-pointer"
                                :to="item.slug !== 'external' ? item.url : null"
                                :href="item.slug === 'external' ? item.url : null"
                                :icon="item.icon"
                                :target="item.target"
                                :isDisabled="item.isDisabled"
                                :slug="item.slug">
                                <span class="truncate">{{ $t(item.i18n) || item.name }}</span>
                                <vs-chip :color="item.tagColor" v-if="item.tag">{{ item.tag }}</vs-chip>
                            </h-nav-menu-item>
                        </div>

                        <!-- If it's group -->
                        <template v-else>
                            <h-nav-menu-group
                                v-if="checkMenuGroup(item)"
                                class="menu-group relative py-4 mr-1"
                                bottom
                                :key="`group-${index}`"
                                :group="item"
                                :groupIndex="index"
                                :open="checkGrpChildrenActive(item)"/>
                        </template>

                    </li>
                </ul>
            </vs-navbar>
<!--        </div>-->
    </div>
</template>

<script>
import HNavMenuGroup from "./HorizontalNavMenuGroup.vue"
import HNavMenuHeader from "./HorizontalNavMenuHeader.vue"
import HNavMenuItem from "./HorizontalNavMenuItem.vue"

export default {
    props: {
        // navbarColor  : { type: String, default: "#fff", },
        navMenuItems: {type: Array, required: true},
    },
    components: {
        HNavMenuGroup,
        HNavMenuHeader,
        HNavMenuItem,
    },
    computed: {
        navbarColor() {
            return this.$store.state.theme === "dark" ? "#000000" : "#fff"
        },
        checkMenuGroup() {
            return (item) => {
                if (this.$acl.check(this.$route.meta.rule) && item.space === localStorage.getItem('work_space')) {
                    if (item.rule === "organization_user") {
                        let userInfo = JSON.parse(localStorage.getItem('userInfo') || {});
                        if (userInfo.userRole === 'user') {
                            let groupMenuPermissions = this.$store.state.permissionsInfo.map(x => x.functionScreenPrefix);
                            if (groupMenuPermissions.find(x => x === item.url) || groupMenuPermissions.find(x => x === item.prefix)) {
                                return true;
                            }
                            return false;
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            }
        },
        isGroupActive() {
            return (item) => {
                const path = this.$route.fullPath
                const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
                let open = false

                let func = (item) => {
                    if (item.submenu) {
                        item.submenu.forEach((item) => {
                            if (item.url && (path === item.url || routeParent === item.slug)) {
                                open = true
                            } else if (item.submenu) {
                                func(item)
                            }
                        })
                    }
                }
                func(item)
                return open
            }
        },
        menuItemsUpdated() {
            let clone = this.navMenuItems.slice()

            for (let [index, item] of this.navMenuItems.entries()) {
                if (item.header && item.items.length && (index || 1)) {
                    let i = clone.findIndex(ix => ix.header === item.header)
                    for (let [subIndex, subItem] of item.items.entries()) {
                        clone.splice(i + 1 + subIndex, 0, subItem)
                    }
                }
            }

            return clone
        },
        workSpaceCss() {
            let space = localStorage.getItem('work_space');
            if (space === 'hrm') return true;
            return false
        },
        isChatCss() {
            let chat = JSON.parse(localStorage.getItem('isChat'));
            if (chat) return true;
            return false;
        },

        checkWorkSpaceNavItem() {
            return (item) => {
                if (item.space) {
                    let space = localStorage.getItem('work_space');
                    if (item.space === space) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }
        },
        workSpaceData() {

            return JSON.parse(localStorage.getItem('work_space_list'))
        },
    },
    methods: {
        checkGrpChildrenActive(group) {
            const path = this.$route.fullPath
            let active = false
            const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

            if (group.submenu) {
                group.submenu.forEach((item) => {
                    if (active) return true
                    if ((path == item.url || routeParent == item.slug) && item.url) {
                        active = true
                    } else if (item.submenu) {
                        this.checkGrpChildrenActive(item)
                    }
                })
            }

            return active
        },
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenu.scss";

.vx-navbar {
    background: none !important;
}
</style>
